<template>
  <Popover ref="popover" :showHeader="true" :headerTitle="title" sizeClass="popover-medium">
    <div class="p-2" v-if="hasEvent">
      <div class="font-weight-bold">Start Time</div>
      <div>{{formatDateTime(routeEvent.startDate)}}</div>
      <div class="font-weight-bold">End Time</div>
      <div>{{formatDateTime(routeEvent.endDate)}}</div>
      <div class="font-weight-bold">User</div>
      <div><LinkUser v-if="taskRoute.user" :id="taskRoute.user.id" :name="taskRoute.user.name" /></div>
      
    </div>
  </Popover>
</template>

<script>
import Popover from '@/components/popover'

import { TaskUserRouteEventTypes, TaskUserRouteEventTypeLookup } from '@/store/types'

export default {
  name: 'MapRouteEventPopover',
  components: {
    Popover
  },
  data() {
    return {
      routeEvent: {},
      taskRoute: {},
      task: {}
    }
  },
  computed: {
    title() {
      if(this.routeEvent) {
        return this.formatLookupName(this.routeEvent.type, TaskUserRouteEventTypeLookup) + ' Route Event'
      }
      return 'Route Event'
    },
    hasEvent() {
      return this.taskRoute.id && this.routeEvent.id
    }
  },
  methods: {
    displayFromElement(element, routeEvent, taskRoute, task) {
      this.$refs.popover.displayFromElement(element)

      // Reset
      this.routeEvent = routeEvent
      this.taskRoute = taskRoute
      this.task = task
    }
  }
}
</script>